import "core-js/modules/es.array.filter.js";

var halve = function halve(isFirstPart) {
  return function (item, index, array) {
    var average = Math.ceil(array.length / 2);
    return isFirstPart ? index < average : index >= average;
  };
};
/**
 * Делит список на две равные части и возвращает часть в зависимости от isFirstPart
 * @param list
 * @param isFirstPart
 */


var filterAndHalve = function filterAndHalve(list, isFirstPart) {
  return list.filter(halve(isFirstPart));
};

export default filterAndHalve;